import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';
import { reviews } from '@/mocks/reviews';

const aboutSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'AboutPage',
      name: '关于福利视频在线',
      description: '福利视频在线品牌介绍、口碑声誉及联系方式',
      url: 'https://fulishipin.com/about',
    },
    {
      '@type': 'Organization',
      name: '福利视频在线',
      url: 'https://fulishipin.com',
      description: '福利视频在线是您发现海量精彩内容的最佳入口，汇聚热门影视、综艺、短视频资源，无需下载即可流畅播放。',
      foundingDate: '2023',
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '400-888-0000',
        contactType: 'customer service',
        email: 'contact@fulishipin.com',
        availableLanguage: ['Chinese'],
      },
      address: {
        '@type': 'PostalAddress',
        addressLocality: '北京市',
        addressRegion: '朝阳区',
        addressCountry: 'CN',
      },
    },
    {
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: '首页',
          item: 'https://fulishipin.com',
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: '关于我们',
        },
      ],
    },
  ],
};

export default function AboutPage() {
  const breadcrumbItems = [
    { label: '首页', href: '/' },
    { label: '关于我们' },
  ];

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutSchema) }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <div className="bg-background-100 border-b border-background-200/60">
            <div className="container-custom">
              <Breadcrumb items={breadcrumbItems} />
              <div className="pb-8 text-center">
                <h1 className="text-3xl md:text-4xl font-heading text-foreground-950 mb-3">
                  关于我们
                </h1>
                <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
                  致力于为用户提供优质免费的视频观看体验
                </p>
              </div>
            </div>
          </div>

          <section className="section-padding">
            <div className="container-custom max-w-[860px]">
              <div className="mb-14">
                <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-5">
                  品牌介绍
                </h2>
                <div className="prose prose-sm md:prose-base max-w-none text-foreground-700 leading-relaxed space-y-4">
                  <p>
                    <strong>福利视频在线</strong>成立于2023年，是一个致力于为全球华语用户提供免费高清视频资源的在线平台。我们汇聚了海量的影视、综艺、短视频、动漫、纪录片、体育赛事、音乐MV和教育学习等丰富内容，旨在让每一位用户都能轻松便捷地享受优质的视频娱乐体验。
                  </p>
                  <p>
                    平台自创立以来，始终秉持<strong>"免费、高清、便捷"</strong>的核心理念，不断优化技术架构和内容分发能力。通过智能推荐算法和精细化的内容分类，我们帮助用户快速找到自己喜爱的视频内容，节省搜索时间，提升观看体验。
                  </p>
                  <p>
                    福利视频在线支持PC电脑、平板、手机等多种设备访问，采用响应式设计技术，自动适配不同屏幕尺寸。平台所有视频均支持多档清晰度选择，最高可达1080P全高清画质，满足用户在不同网络环境下的观看需求。
                  </p>
                  <p>
                    作为一家以用户体验为核心的内容平台，<strong>福利视频在线</strong>不需要用户注册或付费订阅，即点即看，真正实现零门槛享受视频娱乐。我们相信，优质的视频内容应该被所有人自由地获取和分享。
                  </p>
                </div>
              </div>

              <div className="relative rounded-lg overflow-hidden mb-14">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20warm%20toned%20office%20interior%20with%20creative%20team%20collaboration%2C%20soft%20natural%20lighting%2C%20minimalist%20workspace%20design%2C%20digital%20screens%20displaying%20video%20content%2C%20comfortable%20atmosphere%2C%20professional%20yet%20relaxed%20vibe&width=1200&height=500&seq=about-brand-hero&orientation=landscape"
                  alt="福利视频在线团队"
                  title="福利视频在线团队"
                  className="w-full object-cover aspect-[2.4/1]"
                />
              </div>

              <div className="mb-14">
                <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-5">
                  用户口碑
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {reviews.map((review) => (
                    <div
                      key={review.id}
                      className="bg-background-100 rounded-lg border border-background-200/60 p-5 hover:border-primary-200 transition-all duration-300"
                    >
                      <div className="flex items-center gap-3 mb-3">
                        <img
                          src={review.avatar}
                          alt={review.name}
                          className="w-10 h-10 rounded-full object-cover"
                        />
                        <div>
                          <p className="text-sm font-medium text-foreground-800">{review.name}</p>
                          <div className="flex items-center gap-0.5">
                            {Array.from({ length: 5 }).map((_, i) => (
                              <i
                                key={i}
                                className={`text-xs ${
                                  i < review.rating
                                    ? 'ri-star-fill text-primary-500'
                                    : 'ri-star-line text-foreground-300'
                                }`}
                              ></i>
                            ))}
                          </div>
                        </div>
                      </div>
                      <p className="text-sm text-foreground-600 leading-relaxed">
                        {review.content}
                      </p>
                      <p className="text-xs text-foreground-400 mt-3">{review.date}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div className="mb-14">
                <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-5">
                  联系我们
                </h2>
                <div className="bg-background-100 rounded-lg border border-background-200/60 p-6 md:p-8">
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-50 text-primary-500">
                        <i className="ri-mail-line text-lg"></i>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-foreground-800 mb-1">电子邮箱</p>
                        <p className="text-sm text-foreground-500">contact@fulishipin.com</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-accent-50 text-accent-500">
                        <i className="ri-phone-line text-lg"></i>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-foreground-800 mb-1">客服电话</p>
                        <p className="text-sm text-foreground-500">400-888-0000</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600">
                        <i className="ri-map-pin-line text-lg"></i>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-foreground-800 mb-1">公司地址</p>
                        <p className="text-sm text-foreground-500">北京市朝阳区科技园区</p>
                      </div>
                    </div>
                  </div>

                  <div className="mt-8 pt-6 border-t border-background-200/60">
                    <h3 className="text-base font-heading text-foreground-900 mb-4">在线留言</h3>
                    <form
                      className="space-y-4"
                      data-readdy-form="true"
                      id="about-contact-form"
                      onSubmit={async (e) => {
                        e.preventDefault();
                        const form = e.currentTarget as HTMLFormElement;
                        const formData = new FormData(form);
                        const hp = formData.get('phone_alt') as string;
                        if (hp && hp.trim() !== '') {
                          const notice = form.querySelector('.form-notice') as HTMLElement;
                          if (notice) {
                            notice.textContent = '留言已提交，我们会尽快回复您！';
                            notice.className = 'form-notice text-sm text-accent-600 mt-3';
                          }
                          form.reset();
                          return;
                        }
                        try {
                          const params = new URLSearchParams();
                          formData.forEach((value, key) => {
                            if (key !== 'phone_alt') {
                              params.append(key, value as string);
                            }
                          });
                          const res = await fetch('https://readdy.ai/api/form/d9qo6nvnahb7382ovcpg', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                            body: params.toString(),
                          });
                          const notice = form.querySelector('.form-notice') as HTMLElement;
                          if (res.ok && notice) {
                            notice.textContent = '感谢您的留言，我们会尽快回复您！';
                            notice.className = 'form-notice text-sm text-accent-600 mt-3';
                            form.reset();
                          } else if (notice) {
                            const responseText = await res.text();
                            notice.textContent = responseText || '提交失败，请稍后重试';
                            notice.className = 'form-notice text-sm text-red-500 mt-3';
                          }
                        } catch {
                          const notice = form.querySelector('.form-notice') as HTMLElement;
                          if (notice) {
                            notice.textContent = '网络错误，请稍后重试';
                            notice.className = 'form-notice text-sm text-red-500 mt-3';
                          }
                        }
                      }}
                    >
                      <input
                        type="text"
                        name="phone_alt"
                        className="hp-field"
                        tabIndex={-1}
                        autoComplete="off"
                        aria-hidden="true"
                        readOnly
                      />
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <div>
                          <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                            姓名 <span className="text-primary-500">*</span>
                          </label>
                          <input
                            type="text"
                            id="contact-name"
                            name="name"
                            required
                            className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-200 bg-background-50 text-foreground-700 placeholder-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                            placeholder="请输入您的姓名"
                          />
                        </div>
                        <div>
                          <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                            邮箱 <span className="text-primary-500">*</span>
                          </label>
                          <input
                            type="email"
                            id="contact-email"
                            name="email"
                            required
                            className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-200 bg-background-50 text-foreground-700 placeholder-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                            placeholder="请输入您的邮箱"
                          />
                        </div>
                      </div>
                      <div>
                        <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-700 mb-1.5">
                          主题
                        </label>
                        <input
                          type="text"
                          id="contact-subject"
                          name="subject"
                          className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-200 bg-background-50 text-foreground-700 placeholder-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                          placeholder="请输入留言主题"
                        />
                      </div>
                      <div>
                        <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                          留言内容 <span className="text-primary-500">*</span>
                        </label>
                        <textarea
                          id="contact-message"
                          name="message"
                          required
                          maxLength={500}
                          rows={4}
                          className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-200 bg-background-50 text-foreground-700 placeholder-foreground-400 focus:outline-none focus:border-primary-300 transition-colors resize-none"
                          placeholder="请输入您的留言内容（最多500字）"
                        ></textarea>
                        <p className="text-xs text-foreground-400 mt-1">最多500个字符</p>
                      </div>
                      <button
                        type="submit"
                        className="px-8 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
                      >
                        <i className="ri-send-plane-line mr-2"></i>
                        提交留言
                      </button>
                      <div className="form-notice text-sm text-accent-600 mt-3"></div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}